/**
 * 产品管理 H5 绑定账号弹框
 * author: tanyaohua 2020-04-29
 */
'use strict';
angular.module('H5ToolBindAccountModule', [])
    .controller('H5ToolBindAccountCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService', function($scope, $modalInstance, $validation, trsHttpService) {
        initStatus();

        /**
         * [initStatus description]初始化信息
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
            };
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [cancel description] 点击未完成的方法
         * @return {[type]} [description]
         */
        $scope.cancelfail = function() {
            $modalInstance.close('fail');
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $modalInstance.close('success');
        };
    }]);
